import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const ServicesHero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact-cta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Growth <span className="text-blue-600">Services</span>
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Welcome to Upscale, your gateway to comprehensive business elevation. Discover tailored solutions designed to propel your venture to new heights. From strategic marketing to advanced data insights and innovative digital transformation, Upscale is your partner in achieving tangible bottom-line results.
            </p>
            <p className="text-lg font-semibold text-gray-700">
              Experience business transformation with Upscale.
            </p>
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 group shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Book a Meeting
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/3rom5h2m_Growth%20Services_image.png"
                alt="End-to-end growth services built for measurable results — Upscale's connected ecosystem of strategy, channels and data"
                className="w-full h-auto object-cover"
                loading="eager"
              />
            </div>
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;